import { Restricted } from '@apollo/space-kit/illustrations/Restricted';
import React from 'react';

import { ContactSupportButton } from 'src/components/ContactSupportCTAs';
import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';
import { EventCategory } from 'src/lib/analytics';

type EnterpriseRestrictedFeatureProps = {
  analyticsCategory: EventCategory;
  analyticsLabel: string;
};

export const EnterpriseRestrictedFeature = ({
  analyticsCategory,
  analyticsLabel,
}: EnterpriseRestrictedFeatureProps) => {
  const trackCustomEvent = useTrackCustomEvent();

  const handleContactClick = () => {
    trackCustomEvent({
      action: 'contact_us',
      category: analyticsCategory,
      label: analyticsLabel,
    });
  };

  return (
    <div
      className="flex size-full items-center justify-center py-20 text-center"
      data-analytics-category={analyticsCategory}
      data-analytics-label={analyticsLabel}
    >
      <div>
        <Restricted />
        <div className="my-2 max-w-120 text-center text-lg">
          This is an Enterprise feature
        </div>
        <ContactSupportButton
          variant="secondary"
          className="mt-4"
          onClick={handleContactClick}
        >
          Contact us
        </ContactSupportButton>
      </div>
    </div>
  );
};
